import React, {useState} from "react";
import FlexContainer from "connectui/component/layout/FlexContainer";
import {useTheme} from "connectui/theme/ThemeProvider";
import Text from "connectui/component/display/Text";
import ButtonText from "connectui/component/input/button/ButtonText";
import ConnectedPhonesAddEditCard from "../../../../../components/Cards/ConnectedPhonesAddEditCard";
import {messagingSettingsStageEnum} from "../BaseMessagingSettingsPanel";

const PhoneEditPanel = ({setStage, data}) => {
  const {theme} = useTheme();
  const {type, phone} = data;
  const phoneState = useState(phone?.phone || "");
  // Apparently this is only true when ADDING a display only phone number
  const displayOnlyState = useState(type === "display_only" && !phone);

  return (
    // Temporary
    <ConnectedPhonesAddEditCard
      phoneState={phoneState}
      displayOnlyState={displayOnlyState}
      handlePanel3Open={(open) => {
        setStage({
          id: messagingSettingsStageEnum.settings,
          data: null,
        });
      }}
    />
  );
};

export default PhoneEditPanel;
